import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { ProductContext } from '../../App';

function EditSell(props) {
    const product_context = useContext(ProductContext);
    const { setIsLoading, alert, setAlert } = product_context;

    const { editSell, setEditSell } = props;

    const { isOpen, order } = editSell;

    const [editInputs, setEditInputs] = useState({
        price: '',
        courier_code: '',
        delivery_instructions: '',
        customer_name: '',
        customer_address: '',
        contact_number: '',
    });

    useEffect(() => {
        setEditInputs({
            price: order?.price,
            courier_code: order?.courier_code,
            delivery_instructions: order?.delivery_instructions,
            customer_name: order?.customer_details?.name,
            customer_address: order?.customer_details?.address,
            contact_number: order?.customer_details?.contact_number,
        })
    }, [isOpen, order])

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        setEditInputs({ ...editInputs, [name]: value });
    }

    const handleEditSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let data = {
            status: order.status,
            delivery_charge: order.delivery_charge,
            price: editInputs?.price,
            courier_code: editInputs?.courier_code,
            courier_partner: e.target.courier_partner.value,
            delivery_instructions: editInputs?.delivery_instructions,
            payment_method: e.target.payment_method.value,
            payment: e.target.payment.value,
            customer_details: {
                name: editInputs?.customer_name,
                instagram_id: order?.customer_details?.instagram_id,
                address: editInputs?.customer_address,
                contact_number: editInputs?.contact_number,
            }
        }

        axios.put(`${process.env.REACT_APP_SERVER_DOMAIN}/sell/modify/${order._id}`, data)
            .then(res => {
                setIsLoading(false);
                setAlert({
                    isOpen: true,
                    message: "Successfull",
                    type: "success",
                })
                document.body.classList.remove('remove-scroll');
                setEditSell({ ...editSell, isOpen: false });
                props.setChangeSellsState(!props.changeSellsState);
            })
            .catch(err => {
                setAlert({
                    isOpen: true,
                    message: "Something Went Wrong",
                    type: "danger",
                })
                setIsLoading(false);
            })
        setTimeout(() => {
            setAlert({ ...alert, isOpen: false });
        }, 5000);
    }
    const paymentMethods = ['COD', 'Online', 'Cash', 'Credit'];
    const courierPartners = ['Self', 'Buddha Courier', 'NCM'];

    return (
        <>
            {isOpen ? <div className='back'>
                <div className="edit-container flex-column">
                    <h2>Edit</h2>
                    <div className="edit-form">
                        <form onSubmit={handleEditSubmit}>
                            <div className="overflow-handle flex-column">
                                <div className="inputs">
                                    <label htmlFor="customer_name">Customer Name</label>
                                    <input type="text"
                                        value={editInputs?.customer_name}
                                        placeholder='Enter Name' name='customer_name'
                                        onChange={(e) => { handleInputChange(e) }}
                                    />
                                </div>
                                <div className="inputs">
                                    <label htmlFor="customer_address">Address</label>
                                    <input type="text"
                                        value={editInputs?.customer_address}
                                        placeholder='Enter address' name='customer_address'
                                        onChange={(e) => { handleInputChange(e) }}
                                    />
                                </div>
                                <div className="inputs">
                                    <label htmlFor="contact_number">Contact</label>
                                    <input type="number"
                                        value={editInputs?.contact_number}
                                        placeholder='Enter contact number' name='contact_number'
                                        onChange={(e) => { handleInputChange(e) }}
                                    />
                                </div>
                                <div className="inputs">
                                    <label htmlFor="price">Price</label>
                                    <input type="number"
                                        value={editInputs?.price}
                                        placeholder='Enter Price' name='price'
                                        onChange={(e) => { handleInputChange(e) }}
                                    />
                                </div>
                                <div className="inputs">
                                    <label htmlFor="payment_method">Payment Method</label>
                                    <select
                                        required
                                        className="form-select"
                                        name="payment_method"
                                        aria-label="Default select example"
                                    >
                                        {paymentMethods.map((m, i) => {
                                            return (
                                                order?.payment_method === m ? <option key={i} selected value={m}>{m}</option> : <option key={i} value={m}>{m}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                                <div className="inputs">
                                    <label htmlFor="payment">Payment</label>
                                    <select
                                        required
                                        className="form-select"
                                        name="payment"
                                        aria-label="Default select example"
                                    >
                                        {order.payment ? order.payment === 'Pending' ? <><option value="Pending">Pending</option><option value="Received">Received</option></> : <><option value="Received">Received</option><option value="Pending">Pending</option></> : <><option value="Pending">Pending</option><option value="Received">Received</option></>}

                                    </select>
                                </div>
                                {order?.purchase_type === 'online' ? <>
                                    <div className="inputs">
                                        <label htmlFor="courier_partner">Courier Partner</label>
                                        <select
                                            required
                                            className="form-select"
                                            name="courier_partner"
                                            aria-label="Default select example"
                                        >
                                            {courierPartners.map((m, i) => {
                                                return (
                                                    order?.courier_partner === m ? <option key={i} selected value={m}>{m}</option> : <option key={i} value={m}>{m}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                    <div className="inputs">
                                        <label htmlFor="courier_code">Courier Code</label>
                                        <input type="text"
                                            value={editInputs?.courier_code}
                                            placeholder='Enter Courier Code' name='courier_code'
                                            onChange={(e) => { handleInputChange(e) }}
                                        />
                                    </div>
                                    <div className="inputs">
                                        <label htmlFor="delivery_instructions">Delivery Instructions</label>
                                        <input type="text"
                                            value={editInputs?.delivery_instructions}
                                            placeholder='Enter Delivery Instructions' name='delivery_instructions'
                                            onChange={(e) => { handleInputChange(e) }}
                                        />
                                    </div>
                                </> : null}

                            </div>
                            <div className="">
                                <button type='submit' className="btn btn-success me-2">Ok</button>
                                <button type="button" className='btn btn-danger ms-2' onClick={() => {
                                    setEditSell({ ...editSell, isOpen: false });
                                    document.body.classList.remove('remove-scroll');
                                }} >Close</button>
                            </div>
                        </form>
                    </div>

                </div>
            </div> : null}
        </>
    )
}

export default EditSell
